const customEnv = process.env.REACT_APP_ENV || "development";

// config.js
const configs = {
  development: {
    baseURL: "http://localhost:3034/rl-order",
    coreUrl: "http://localhost:3034/api",
  },
  test: {
    baseURL: "https://rl.oms.yoctotta.com/rl-order",
    coreUrl: "https://rl.yoctotta.com/api",
  },
  uat: {
    baseURL: "https://uat.oms.dropskip.app/rl-order",
    coreUrl: "https://uat.dropskip.app/api",
  },
  production: {
    baseURL: "https://oms.dropskip.app/rl-order",
    coreUrl: "https://dropskip.app/api",
  },
};

// Get config based on environment
const config = configs[customEnv];

// Log current environment (remove in production)
console.log(`Running in ${customEnv} environment`);

export default config;
